<template>
    <div>
        <div class="cms-content-careers-latest-roles__header">
            <h2 v-if="roles && roles.businessArea" class="">Latest {{roles.businessArea}} Roles</h2>
            <h2 v-else class="">Latest Roles</h2>
            <a @click="viewResults(roles.businessArea)" type="button" class="btn btn--blue cms-content-careers-latest-roles__header--button ">View all
                <span v-if="roles && roles.businessArea"> {{ roles.businessArea }} </span>  roles</a>
        </div>

        <template v-if="roles">
            <careers-results-card v-for="(result, index) in roles.roles" :result="result" :index="index" :result_url="view_url" :key="'careers-results-card' + index"></careers-results-card>
        </template>

        <div class=" cms-content-careers-latest-roles__footer">
            <a @click="viewResults(roles.businessArea)" type="button" class="btn btn--blue ">View all
                <span v-if="roles && roles.businessArea"> {{ roles.businessArea }} </span> roles</a>
        </div>
    </div>
</template>

<script>
import CareersResultsCard from '../components/CareersResultsCard.vue'

export default {
    props: [
        'latest_roles',
        'view_url',
        'results_url'
        ],

    components: {
        CareersResultsCard
    },
    data() {
        return {
            shareOptionsOpen: null,
            roles:[]
        };
    },

    mounted(){
        this.roles = this.latest_roles;
    },
    methods:{
        viewResults(business_area){
            if(business_area == null){
                business_area = ''
            }
            window.location.href = this.results_url.replace('replace', business_area);
        },
    }
}

</script>




// WEBPACK FOOTER //
// resources/assets/js/careers/latest-roles/LatestRoles.vue